const translations = {
    createAam: 'Create As Applied Map'
};

export default translations;
